<template>
  <div id="app">
    <Navbar></Navbar>

    <div class="container">
      <div id="page">
        <Profile></Profile>
        <router-view />
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import Navbar from "./components/Navbar";
import Profile from "./components/Profile";
import Footer from "./components/Footer";

export default {
  name: "App",
  components: {
    Navbar,
    Profile,
    Footer
  }
};
</script>

<style>
body {
  font-family: "Arimo", sans-serif;
}
#page {
  min-height: 500px;
}
.page_heading {
  color: #ce3c54;
  font-size: 24px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue